import React, { useEffect, useState, forwardRef } from "react";
import Modal from "react-modal";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/CloseIcon.svg";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar.svg";
import { ReactComponent as FileIcon } from "../../../../assets/icons/AttachmentIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { notify } from "../../../../util/helpers";
import ViewAssessmentModal from "./ViewAssessmentModal";
import "./RegisteredPatientAssessmentModal.css";
import {
  setAssessmentScore,
  fetchRecentAssessmentsLogic,
  fetchAllAssessmentsLogic,
} from "../../../../store/features/patient/assessmentsSlice";
import {
  singlePatientLogic,
} from "../../../../store/features/patient/patientSlice";
import { error } from "jquery";
import moment from "moment";
// import moment from "moment";
// import moment from "moment-timezone";



const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
    zIndex: 1000, // Ensure overlay is above other elements
  },
  content: {
    top: "50%", // Center vertically
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "90%", // Responsive width
    maxWidth: "600px", // Limit maximum width
    maxHeight: "80vh", // Keep height constraint
    overflowY: "auto", // Enable vertical scrolling
    borderRadius: "16px",
    padding: "0", // Remove default padding to control via content
  },
};

const RegisteredPatientAssessmentModal = (props) => {
  const dispatch = useDispatch();
  const {
    modalIsOpen,
    setModalOpen,
    assessment,
    assessmentName,
    patientId,
    modalName,
    data,
    setPatientAssessments,
    setCaregiverAssessments,
  } = props;

  function toggleModal() {
    setModalOpen(!modalIsOpen);
  }
  const { assessmentTypes } = useSelector((state) => state?.assessment);
  const { singlePatientData } = useSelector((state) => state?.patient);
  const [assessmentSelected, setAssessmentSelected] = useState(null);
  const [assesmentNames, setAssesmentNames] = useState([]);
  const [qnAModal, showQnAModal] = useState(false);
  const [selectedGapDays, setSelectedGapDays] = useState(null);
  const [assessmentDate, setAssessmentDate] = useState(null);
  const [scoreOption, setScoreOption] = useState("answerIndividually");
  const [score, setScore] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  let today = moment(new Date()).format("YYYY-MM-DD");
  const fiveDaysFromToday = moment(today)
      .subtract(6, "months")
      .format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(fiveDaysFromToday);
  const [endDate, setEndDate] = useState(today);
  const { user, selectedProvider, selectedClinic } = useSelector(
    (state) => state.app
  );

  // Reset form fields when modal opens
  useEffect(() => {
    if (modalIsOpen) {
      setAssessmentSelected(null);
      setAssessmentDate(null);
      setScore("");
    //   setScoreOption("answerIndividually");
    //   setSelectedFile(null);
    }
  }, [modalIsOpen]);

  useEffect(() => {
      const tempAssesmentNames = assessmentTypes?.map((element) => {
        if (assessment?.assessment_name === element.name) {
          setAssessmentSelected({ label: element.name, value: element.id });
        }
        return { label: element.name, value: element.id };
      });
  
      try {
        setSelectedGapDays(assessment?.gap_days?.toString());
      } catch (e) {
        console.log(e);
      }
  
      setAssesmentNames(tempAssesmentNames);
    }, []);
    
  // function toggleModal() {
  //   setModalOpen(!modalIsOpen);
  // }
  const CustomInput = forwardRef(({ value, onClick, placeholder }, ref) => (
  <div ref={ref} className="custom-datepicker-input" onClick={onClick}>
    <input value={value} placeholder={placeholder} readOnly />
    <div className="icon-wrapper">
      {value ? (
        <CloseIcon
          className="close-icon"
          onClick={(e) => {
            e.stopPropagation();
            setAssessmentDate(null);
          }}
        />
      ) : (
        <CalendarIcon className="calendar-icon" />
      )}
    </div>
  </div>
));
// uncomment for future requirement to upload files also
//   const CustomFileInput = forwardRef(({ onChange, placeholder }, ref) => (
//     <div ref={ref} className="custom-file-input">
//       <input
//         type="file"
//         id="referenceFile"
//         onChange={onChange}
//         style={{ display: "none" }}
//       />
//       <label htmlFor="referenceFile" className="file-input-label">
//         {selectedFile ? selectedFile.name : placeholder}
//       </label>
//       {selectedFile ? (
//         <CloseIcon
//           className="close-icon"
//           onClick={(e) => {
//             e.stopPropagation();
//             setSelectedFile(null);
//           }}
//         />
//       ) : (
//         <FileIcon className="file-icon" />
//       )}
//     </div>
//   ));

  function handleAssessmentSelected(e) {
    setAssessmentSelected(e);
  }
  const handleScoreChange = (e) => {
    setScore(e.target.value);
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const formattedDate = assessmentDate
      ? moment(assessmentDate).format("YYYY-MM-DD 00:01:01")
      : null;
    // Validation for required fields
      if (!assessmentSelected) {
        notify("Please select an assessment type.", "info");
        return;
      }
      if (!assessmentDate) {
        notify("Please select a date of assessment.", "info");
        return;
      }
      if (!score) {
        notify("Please enter a score.", "info");
        return;
      }
    const payload = {
      patient: patientId,
      assessment: assessmentSelected.value,
      created: formattedDate,
      score: score,
    };
    //alert("payload : " + JSON.stringify(payload, null, 2));
    setAssessmentScore(payload).then((response) => {
      if(response.status === 201 || response.status === 200) {
        console.log("response.status",response.status)
           notify("Assessment scheduled successfully!");
           //fetchRecentAssessmentsLogic
           dispatch(fetchRecentAssessmentsLogic(patientId.toString()));
            dispatch(
                   fetchAllAssessmentsLogic({
                     patient_id: patientId.toString(),
                     start_date: startDate,
                     end_date: endDate,
                   })
                 );
            console.log("Calling singlePatientLogic",selectedProvider,patientId,selectedClinic?.clinic?.id)
            if (selectedProvider) {
                  const params = {
                    clinic_id: selectedClinic?.clinic?.id,
                    clinician_id: selectedProvider,
                  };
                  console.log("Calling singlePatientLogic in if block",params)
                  dispatch(singlePatientLogic({ id: patientId, params }));
            } 
            else {
                  dispatch(singlePatientLogic({ id: patientId }));
                  console.log("Calling singlePatientLogic in else block")
                }
                setModalOpen(false);
      }
      setModalOpen(false);
    }).catch((error => {
        if (error.response && error.response.status === 409) {
        // Conflict error → show API's detail message
        notify(error.response.data.detail || "An assessment has already been recorded for the selected date. Please choose another date", "info");
      } else if(error.response && error.response.status === 400 && error.response?.data?.score){
         notify(error.response.data.score[0] || "Score cannot exceed max possible score.", "info");
      }
      else {
        notify("Something went wrong", "info");
      }
      // setModalOpen(false);
    }))
    
  };

// uncomment for future requirement to upload files also
//   const handleScoreOptionChange = (e) => {
//     setScoreOption(e.target.value);
//     if (e.target.value === "answerIndividually") {
//       setScore("");
//     }
//   };
// const handleFileChange = (e) => {
//     setSelectedFile(e.target.files[0] || null);
//   };
  

  return (
    // <div
    //     className="container-fluid"
    //     style={{ margin: "0px", padding: "2% 2% 4% 2%" }} // Reduced padding
    //   >
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={toggleModal}
        style={customStyles}
        contentLabel=""
        ariaHideApp={false}
      >
        <div
          className="container-fluid"
          style={{ margin: "0px", padding: "2.5%",paddingTop: "10%", paddingBottom: "5%" }}
        >
          <button
            style={{
              position: "absolute",
              right: "15px",
              border: "0px",
              fontFamily: "DM Sans",
              backgroundColor: "transparent",
            }}
            onClick={toggleModal}
          >
            <CloseIcon />
          </button>
          <ViewAssessmentModal
            modalIsOpen={qnAModal}
            setModalOpen={showQnAModal}
            assessmentName={assessmentSelected}
          />
          <CardLayout className="p-3">
            <div className="w-100 py-2 d-flex">
              <h3 className="primary-text-blue">{modalName}</h3>
            </div>
            <form onSubmit={handleSubmit} className="container-fluid p-1">
              <div className="form-group py-3">
                <label>Assessment Type </label>
                <Select
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      padding: "0px",
                      backgroundColor: "transparent",
                      width: "100%", // Responsive width
                      maxWidth: "500px", // Limit maximum width
                      outline: "0px",
                      color: "#94A3B8 !important",
                      border: "none",
                      borderBottom: "1px solid #94A3B8 !important",
                      boxShadow: "none",
                      // Ensure internal elements don’t add padding
                      "& > div": {
                        padding: "0 !important",
                      },
                      minWidth: "0",
                    }),
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  placeholder="Choose Assessment Type"
                  classNamePrefix="select"
                  name="assessment-type"
                  options={assesmentNames}
                  onChange={handleAssessmentSelected}
                  value={assessmentSelected}
                  isDisabled={modalName === "Edit Assessment"}
                  required
                />
              </div>
              {assessmentSelected && (
                <div className="form-group px-2">
                  <a
                    href="javascript:void(0);"
                    rel="noreferrer noopener"
                    onClick={() => {
                      showQnAModal(true);
                    }}
                  >
                    View Assessment Questions
                  </a>
                </div>
              )}

                <div className="form-group py-3">
                  <label>Date Of Assessment</label>
                  <DatePicker
                    selected={assessmentDate}
                    onChange={(date) => setAssessmentDate(date)}
                    // showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    dateFormat="yyyy-MM-dd"
                    customInput={<CustomInput />}
                    placeholderText="Select date"
                    popperPlacement="bottom-start"
                    popperProps={{
                      modifiers: [
                        {
                          name: "preventOverflow",
                          options: { boundary: "viewport", padding: 8 },
                        },
                        {
                          name: "offset",
                          options: { offset: [0, 8] },
                        },
                        {
                          name: "flip",
                          enabled: true, // Enable flipping to avoid overflow
                          fallbackPlacements: ["top-start", "bottom-start"], // Try top if bottom overflows
                        },
                      ],
                    }}
                    popperClassName="custom-datepicker-popper"
                    required
                    maxDate={moment().toDate()}
                  />
                </div>
              {/* For future */}
              {/* <div className="form-group py-3">
                <div className="radio-group">
                  <div className="radio-option">
                    <input
                      type="radio"
                      id="enterTotalScore"
                      name="scoreOption"
                      value="enterTotalScore"
                      checked={scoreOption === "enterTotalScore"}
                      onChange={handleScoreOptionChange}
                    />
                    <label htmlFor="enterTotalScore">Enter Total Score</label>
                  </div>
                  <div className="radio-option">
                    <input
                      type="radio"
                      id="answerIndividually"
                      name="scoreOption"
                      value="answerIndividually"
                      checked={scoreOption === "answerIndividually"}
                      onChange={handleScoreOptionChange}
                    />
                    <label htmlFor="answerIndividually">Answer Question Individually</label>
                  </div>
                </div>
              </div> */}
              <div className="form-group py-3">
                  <label>Score</label>
                  <input
                    type="number"
                    className="score-input"
                    value={score}
                    onChange={handleScoreChange}
                    placeholder="Enter score"
                    required
                    style={{ width: "100%", maxWidth: "500px" }} // Responsive width
                  />
                </div>
               {/* For future */} 
              {/* {scoreOption === "enterTotalScore" && (
                <div className="form-group py-3">
                  <label>Score</label>
                  <input
                    type="number"
                    className="score-input"
                    value={score}
                    onChange={handleScoreChange}
                    placeholder="Enter score"
                    style={{ width: "50rem" }}
                  />
                </div>
              )} */}
              {/* <div className="form-group py-3">
                <label>Attach Reference File</label>
                <CustomFileInput
                  onChange={handleFileChange}
                  placeholder="Select a file"
                />
              </div> */}
              <div
                className="d-flex justify-content-end mt-5"
                style={{ gap: "2%" }}
              >
                <button className="btn alternative-btn" onClick={toggleModal}>
                  Cancel
                </button>

                <button
                  type="submit"
                  className="primary-btn"
                >
                  Submit
                </button>
              </div>
            </form>
          </CardLayout>
        </div>
      </Modal>
  );
};
export default RegisteredPatientAssessmentModal;
